import { Popup } from "react-map-gl";
import { Link } from "../../shims/useNavigate";

import { Property } from "../../rest/responses/Property";

import Button from "../UI/Button/Button";
import EpcRatingTile from "../UI/EpcRatingTile/EpcRatingTile";
import ThermalRatingTile from "../UI/ThermalRatingTile/ThermalRatingTile";
import EmbeddedCarousel from "../UI/DataTable/EmbeddedCarousel";
import { ImageUrl } from "../../types/types";

interface PropertyPopupProps {
	property: Property;
	onClose: Function;
}

export default function PropertyPopup({ property, onClose }: PropertyPopupProps) {
	// NB: property as in property belonging to an object, as opposed to domestic property plural. Quirk of Mapbox naming and DREam.
	const thermalScore =
		property["image_meta.insulation_performance"] != null
			? Number(property["image_meta.insulation_performance"])
			: null;
	return (
		<Popup
			key={property.id}
			longitude={Number(property["location.lng"])}
			latitude={Number(property["location.lat"])}
			anchor="bottom"
			onClose={() => onClose()}
		>
			{property["image_meta.image_urls"] && (
				<div className="map-popup-image">
					<EmbeddedCarousel imageUrls={property["image_meta.image_urls"] as unknown as ImageUrl[]} />
				</div>
			)}
			<div className="map-popup-stats">
				{thermalScore != null && (
					<span className="map-popup-stat">
						<span className="map-popup-stat-label">Thermal Rating:</span>
						<ThermalRatingTile score={thermalScore} />
					</span>
				)}
				<span className="map-popup-stat">
					<span className="map-popup-stat-label">EPC:</span>
					<EpcRatingTile grade={String(property["metrics.epc_rating_grade"] ?? "")} />
				</span>
				<span className="map-popup-stat">
					<span className="map-popup-stat-label">Integrity:</span>
					<span>{property["data_integrity.value"]}</span>
				</span>
			</div>
			<div className="map-popup-address">
				<strong>Address</strong>
				<address>
					{property["location.addr_no"]},{" " + property["location.addr_street"]}
					<br />
					{property["location.addr_city"]}
					<br />
					{property["location.postcode"]}
				</address>
			</div>
			<Link
				to={{
					pathname: `/epc-data/${property.id}`,
					search: "?from=mapping",
				}}
				target="_blank"
				rel="noopener noreferrer"
			>
				<Button variant="contained">View Property</Button>
			</Link>
		</Popup>
	);
}
